import ListItemButton, {
  listItemButtonClasses,
} from '@mui/material/ListItemButton'
import styled from '@mui/material/styles/styled'

/**
 * Geometry for the inset rounded tile the nav rows highlight as. Shared so the
 * Sales Center links and the Map View / Activity Summary / Sales Funnels
 * buttons below them round and inset identically.
 *
 * Applied via `style` rather than `sx` because NavItem is created with
 * `skipSx`. The transparent border reserves room for SideNavLink's selected
 * outline, so rows stay the same size whether or not they can be selected;
 * paired with an 5px icon margin it puts every icon 11px from the drawer edge.
 */
export const navItemTileStyle = {
  marginLeft: '5px',
  marginRight: '5px',
  borderRadius: '8px',
  border: '1px solid transparent',
} as const

/**
 * Label style for every nav row. Regular weight deliberately: semibold is
 * reserved for the selected row, so weight alone tells you which page you are
 * on. Rows that can never be selected (Map View, Activity Summary, Sales
 * Funnels) therefore stay regular.
 */
export const navItemTextStyle = {
  fontSize: '16px',
} as const

/**
 * Glyph size for nav rows. 24px is the grid Material icons are drawn on, but
 * it read as too small here — 30px is the established size for this nav and
 * what it has shipped with.
 *
 * The row's icon box keeps its own 5px left margin, so changing this does not
 * move the icon column.
 */
export const navIconSize = '30px'

export const NavItem = styled(ListItemButton, {
  name: 'NavItem',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(({ theme }) => ({
  height: '52px',
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}))
